<template>
  <ResumeEditor
    v-if="ready"
    ref="editor"
    class="resume-editor"
    :is-edit-mode="isEditMode"
    :is-company-job-editable="isCompanyJobEditable"
    :hidden-id-number="hiddenIdNumber"
    :value="resumeInfo"
    :isNewPage="true"
    :isHr="true"
    :stepSetting="resumeEditorSetting"
    :hrMiniResumeSetting="hrMiniResumeSetting"
    :jobId="jobId"
    @cancel="handleCancel"
    @save="handleSave"
    @save-back="handleSaveAndBack"
    @hrSwitchMiniResumeChange="handleHrSwitchMiniResumeChange"
    @onlyTalentPoolChange="handleOnlyTalentPoolChange"
  />
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { STEP_TYPE } from '@/constant/candidate'
import { mixedRouterPush } from '@/router/routes'
import ResumeEditor from '@/components/candidate/editor/layout.vue'

export default {
  components: {
    ResumeEditor
  },
  data () {
    const vm = this
    return {
      ready: false,
      readyPromise: [],
      hiddenIdNumber: true,
      resumeInfo: {
        open_question: {
          hr: []
        }
      },
      resumeEditorSetting: {
        showEdit: false,
        hiddenStep: [],
        displayStep: [],
        [STEP_TYPE.UPLOAD_RESUME]: {
          hiddenField: [],
          needUploadResume: false
        },
        [STEP_TYPE.BASE_INFO]: {},
        [STEP_TYPE.WORK_EXPERIENCE]: {},
        [STEP_TYPE.EDUCATION]: {},
        [STEP_TYPE.LANGUAGE]: {},
        [STEP_TYPE.DESCRIPTION]: {
          hiddenField: []
        }
      },
      hiddenStepData: [],
      hrMiniResumeSetting: {
        isHrMiniResume: false,
        isHrSwitchMiniResume: !vm.$route.meta.isEditMode
      },
      needUploadResume: false,
      isSaving: false
    }
  },
  computed: {
    isEditMode () {
      return this.$route.meta.isEditMode
    },
    isBasicInfo () {
      return this.$route.query.is_basic_info === '1'
    },
    jobId () {
      return this.$route.params.jobId
    },
    applicationId () {
      return this.$route.params.applicationId
    },
    isCompanyJobEditable () {
      return !this.isEditMode && this.jobId === '-1'
    }
  },
  created () {
    this.readyPromise.push(this.isHiddenIdNumberField())
    if (this.isEditMode) {
      this.readyPromise.push(this.getResumeInfo())
    } else {
      const jobId = this.jobId
      if (jobId !== '-1') {
        this.readyPromise.push(this.initJobApplyRequiredInfo())
        this.resumeInfo = { baseInfo: { companyJob: parseInt(jobId) } }
      } else {
        this.$set(this.resumeEditorSetting.DESCRIPTION, 'hiddenField', ['source', 'code'])
      }
    }
    this.$eventBus.$emit('showLoading', true)
    Promise.all(this.readyPromise).then(() => {
      this.initUrlParams()
      this.initResumeSetting()
      this.ready = true
    }).finally(() => {
      this.$eventBus.$emit('showLoading', false)
    })
  },
  mounted () {
  },
  methods: {
    ...mapActions('application', ['createApplicationWithResume', 'getApplicationResumeInfo', 'updateApplicationResume', 'hasIdNumberField', 'uploadApplicationCandidatePhoto', 'getJobApplyRequiredInfo']),
    async handleHrSwitchMiniResumeChange (value) {
      const targetStep = {
        stepType: STEP_TYPE.BASE_INFO
      }
      this.hrMiniResumeSetting.isHrMiniResume = value
      if (this.hrMiniResumeSetting.isHrMiniResume) {
        this.$refs.editor.currentStepIndex = 0
        const hiddenStep = [STEP_TYPE.DESCRIPTION, STEP_TYPE.EDUCATION, STEP_TYPE.WORK_EXPERIENCE, STEP_TYPE.LANGUAGE, STEP_TYPE.ADDITIONAL_INFO, STEP_TYPE.PRESCREEN_QUESTIONNAIRE, STEP_TYPE.JOB_QUESTIONNAIRE, STEP_TYPE.INVITE_QUESTIONNAIRE, STEP_TYPE.HR_QUESTIONNAIRE, STEP_TYPE.ONBOARDING_QUESTIONNAIRE]
        if (!this.needUploadResume) {
          hiddenStep.push(STEP_TYPE.UPLOAD_RESUME)
        }
        this.resumeEditorSetting.hiddenStep = hiddenStep
        this.hiddenStepData = ['commentAndTagInfo', 'additionalInfo', 'educationInfo', 'workExperienceInfo', 'languageInfo', 'open_question']
        this.$set(this.resumeEditorSetting.BASE_INFO, 'hiddenField', [
          'photo',
          'gender',
          'birthday',
          'salutation',
          'currentLocation',
          'homeLocation',
          'address',
          'otherAddress',
          'secondPhone',
          'idNumber',
          'chatTool',
          'socialNetwork',
          'personalStatement',
          'expectedSalary'
        ])
      } else {
        this.resumeEditorSetting.hiddenStep = []
        this.$set(this.resumeEditorSetting.BASE_INFO, 'hiddenField', [])
        this.hiddenStepData = []
      }
      if (this.needUploadResume && !this.$refs.editor?.candidateInfo?.isUpload === true) {
        targetStep.stepType = STEP_TYPE.UPLOAD_RESUME
      }
      await this.$refs.editor.showStepPage(targetStep)
    },
    handleOnlyTalentPoolChange (onlyTalentPool) {
      if (onlyTalentPool) {
        this.$set(this.resumeEditorSetting.DESCRIPTION, 'hiddenField', ['source', 'code'])
      } else {
        this.$set(this.resumeEditorSetting.DESCRIPTION, 'hiddenField', [])
      }
    },
    async isHiddenIdNumberField () {
      this.hiddenIdNumber = !await this.hasIdNumberField()
    },
    async getResumeInfo () {
      const resp = await this.getApplicationResumeInfo(this.applicationId)
      if (resp) {
        this.resumeInfo = resp
      }
    },
    async initJobApplyRequiredInfo () {
      // 编辑简历的时候不需要查找
      if (this.isEditMode) {
        return
      }
      if (this.jobId) {
        const resp = await this.getJobApplyRequiredInfo(this.jobId)
        if (resp) {
          if ((resp.required_field || []).includes('resume')) {
            this.needUploadResume = true
          }
        }
      }
    },
    async initResumeSetting () {
      if (this.needUploadResume) {
        this.resumeEditorSetting[STEP_TYPE.UPLOAD_RESUME].needUploadResume = true
      }
      if (this.isBasicInfo) {
        this.hrMiniResumeSetting.isHrMiniResume = true
        await this.$nextTick()
        const hiddenStep = [STEP_TYPE.DESCRIPTION, STEP_TYPE.EDUCATION, STEP_TYPE.WORK_EXPERIENCE, STEP_TYPE.LANGUAGE, STEP_TYPE.ADDITIONAL_INFO, STEP_TYPE.PRESCREEN_QUESTIONNAIRE, STEP_TYPE.JOB_QUESTIONNAIRE, STEP_TYPE.INVITE_QUESTIONNAIRE, STEP_TYPE.HR_QUESTIONNAIRE, STEP_TYPE.ONBOARDING_QUESTIONNAIRE]
        if (!this.needUploadResume) {
          hiddenStep.push(STEP_TYPE.UPLOAD_RESUME)
        }
        this.resumeEditorSetting.hiddenStep = hiddenStep
        this.hiddenStepData = ['commentAndTagInfo', 'additionalInfo', 'educationInfo', 'workExperienceInfo', 'languageInfo', 'open_question']
        this.$set(this.resumeEditorSetting.BASE_INFO, 'hiddenField', [
          'photo',
          'gender',
          'birthday',
          'salutation',
          'currentLocation',
          'homeLocation',
          'address',
          'otherAddress',
          'secondPhone',
          'idNumber',
          'chatTool',
          'socialNetwork',
          'personalStatement',
          'expectedSalary'
        ])
      }
    },
    initUrlParams () {
      if (!this.isEditMode) {
        return
      }
      const stepType = STEP_TYPE.BASE_INFO
      if (this.$route.query.step) {
        return
      }
      const query = { ...this.$route.query, step: stepType }
      this.$router.replace({ query })
    },
    async handleCancel () {
      mixedRouterPush(this.$route.query.back || `/candidates/${this.jobId}`)
    },
    async handleSave (resumeInfo, autoBack) {
      if (this.isSaving) {
        return
      }
      this.isSaving = true
      this.$eventBus.$emit('showLoading', true)
      if (!this.isEditMode) {
        _.forEach(resumeInfo, (val, key) => {
          if (_.includes(this.hiddenStepData, key)) {
            this.$delete(resumeInfo, key)
          }
        })
        _.forEach(resumeInfo.baseInfo, (val, key) => {
          if (_.includes(this.resumeEditorSetting.BASE_INFO.hiddenField, key)) {
            this.$delete(resumeInfo.baseInfo, key)
          }
          if (_.includes(this.resumeEditorSetting.BASE_INFO.hiddenField, 'chatTool')) {
            this.$set(resumeInfo.baseInfo, 'chatTool', [])
          }
          if (_.includes(this.resumeEditorSetting.BASE_INFO.hiddenField, 'socialNetwork')) {
            this.$set(resumeInfo.baseInfo, 'socialNetwork', [])
          }
          if (_.includes(this.resumeEditorSetting.BASE_INFO.hiddenField, 'homeLocation')) {
            this.$delete(resumeInfo.baseInfo, 'city')
            this.$delete(resumeInfo.baseInfo, 'province')
            this.$delete(resumeInfo.baseInfo, 'country')
          }
          if (_.includes(this.resumeEditorSetting.BASE_INFO.hiddenField, 'currentLocation')) {
            this.$delete(resumeInfo.baseInfo, 'currentCity')
            this.$delete(resumeInfo.baseInfo, 'currentCountry')
            this.$delete(resumeInfo.baseInfo, 'currentProvince')
          }
          if (_.includes(this.resumeEditorSetting.BASE_INFO.hiddenField, 'expectedSalary')) {
            this.$delete(resumeInfo.baseInfo, 'salary')
            this.$delete(resumeInfo.baseInfo, 'currency')
          }
        })
      }
      try {
        const photoFile = resumeInfo.baseInfo?.photoFile
        resumeInfo = {
          ...resumeInfo,
          baseInfo: {
            ...resumeInfo.baseInfo,
            photo: photoFile ? null : resumeInfo.baseInfo.photo,
            photoFile: null
          }
        }
        let resp = null
        if (this.isEditMode) {
          resp = await this.updateApplicationResume({ applicationId: this.applicationId, resumeInfo })
        } else {
          resp = await this.createApplicationWithResume(resumeInfo)
        }
        if (resp) {
          if (photoFile) {
            const candidateId = resp.candidate_id
            const jobId = resp.job_id
            await this.uploadApplicationCandidatePhoto({ candidateId, jobId, photo: photoFile })
          }
          this.$message.success(this.$t('common.message.saveSuccess'))
          if (autoBack) {
            mixedRouterPush(this.$route.query.back || `/candidates/${this.jobId}`)
          }
        }
      } catch (err) {
        if (err.code !== 500) {
          const editorRef = this.$refs.editor
          const targetStep = _.find(editorRef.activeStepConfigList, { stepType: STEP_TYPE.BASE_INFO })
          await editorRef.showStepPage(targetStep)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.isSaving = false
      }
    },
    handleSaveAndBack (jobTemplateInfo) {
      return this.handleSave(jobTemplateInfo, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.resume-editor {
  min-width: 1325px;
  overflow: auto;
}
</style>
